import { useEffect, useState } from "react";
import { useAuth } from "../../lib/auth";
import { useIntl } from "../../lib/i18n";
import { apiJSON } from "../../lib/api";

type WhoAmI = {
  sub: string;
  tenantId: string;
  tenantSlug: string;
  email: string;
  roles: string[];
};

export default function ProfilePage() {
  const { session } = useAuth();
  const { t } = useIntl();
  const [me, setMe] = useState<WhoAmI | null>(null);

  useEffect(() => {
    if (!session) return;
    apiJSON<WhoAmI>("/api/v1/me", { token: session.token }).then(setMe).catch(() => null);
  }, [session]);

  return (
    <div>
      <h1 className="text-2xl font-semibold text-brand-900">{t("nav.profile")}</h1>
      <dl className="mt-6 grid grid-cols-1 gap-2 rounded-xl bg-white p-5 shadow-sm ring-1 ring-slate-200 sm:grid-cols-2">
        <dt className="text-xs uppercase tracking-wide text-slate-500">{t("profile.email")}</dt>
        <dd>{me?.email ?? "—"}</dd>
        <dt className="text-xs uppercase tracking-wide text-slate-500">{t("profile.firm")}</dt>
        <dd>{me?.tenantSlug ?? session?.tenantSlug ?? "—"}</dd>
        <dt className="text-xs uppercase tracking-wide text-slate-500">{t("profile.roles")}</dt>
        <dd>{me?.roles.join(", ") ?? "—"}</dd>
      </dl>
    </div>
  );
}
